import { Action, createAction, props } from "@ngrx/store";

export const setMobileCart = createAction(
	"[CART] UPDATE_MOBILE_PLAN_CART",
	props<{ cart: { mobile: { basePlan: any } } }>()
);
export const setMobileCartTemporary = createAction(
	"[CART] UPDATE_MOBILE_PLAN_CART_TEMPORARY",
	props<{ dueToday: any; details: any }>()
);
export const setMobileAddonsCart = createAction(
	"[CART] UPDATE_MOBILE_ADDONS_CART",
	props<{ cart: { mobile: { addons: any } } }>()
);
export const setAddressCart = createAction(
	"[CART] SET_ADDRESS_CART",
	props<{ address: string }>()
);
export const setCartProductName = createAction(
	"[CART] SET_PRODUCT_NAME_CART",
	props<{ currentProduct: string }>()
);

export const setSimType = createAction(
	"[CART] SET_SIM_TYPE",
	props<{ simType: string }>()
);
